import axios from 'axios';

import { getStorageValue } from '../utils/cookies';

const API_SERVER_URL = import.meta.env.VITE_API_URL;
const accessLoginToken = getStorageValue('access_token');
axios.defaults.headers.common.Authorization = `Bearer ${accessLoginToken}`;

// custom axios instance without authorization header.
const axiosNoAuth = axios.create();
const setTokenForNoAuthUser = () => {
  const newHireNoAuthToken = getStorageValue('onBoarding_token');
  axiosNoAuth.defaults.headers.common.Authorization = `Bearer ${newHireNoAuthToken}`;
}


/**
 * Gets the API data from the server.
 * @param url - the url to get the data from.
 */
export const getApi = (url: string, config?: any) => axios.get(API_SERVER_URL + url, config);


export const noAuthGetApi = (url: any, config?: any) => {
  // setTokenForNoAuthUser();
  return axiosNoAuth.get(API_SERVER_URL + url, config);
};

export const noAuthPostApi = (url: any, data?: any, config?: any) => {
  // setTokenForNoAuthUser();
  return axiosNoAuth.post(API_SERVER_URL + url, data, config);
};

export const noAuthPutApi = (url: any, data?: any, config?: any) => {
  setTokenForNoAuthUser();
  return axiosNoAuth.put(API_SERVER_URL + url, data, config);
};

/**
 * Posts data to the API server.
 * @param url - the url to post to.
 * @param data - the data to post.
 * @param shortUrl - whether or not to use the short url.
 */
export const postApi = (
  url: string,
  data?: any,
  config?: any,
  shortUrl: boolean = true
) => axios.post((shortUrl ? API_SERVER_URL : "") + url, data, config);

/**
 * Sends a PUT request to the API server.
 * @param url - the url to upadte.
 * @param data - the data to update.
 * @param shortUrl - whether or not to use the short url.
 */
export const putApi = (
  url: string,
  data?: any,
  config?: any,
  shortUrl: boolean = true
) => axios.put((shortUrl ? API_SERVER_URL : "") + url, data, config);

/**
 * Delete API - Delete data from the server.
 * @param url - the url to delete the data.
 */
export const deleteApi = (url: string) => axios.delete(API_SERVER_URL + url);
